import toggleButtonVisibility from "./toggle-button-visibility"

export default function initialState(buttonLeft, buttonRight, update) {
  toggleButtonVisibility.display(buttonLeft, true)
  toggleButtonVisibility.display(buttonRight, true)
  update()
}
